"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createNoActionStepOutput = void 0;
const createNoActionStepOutput = (input) => {
    return {
        crossContractCalls: [],
        outputERC20Amounts: input.erc20Amounts,
        outputNFTs: input.nfts,
    };
};
exports.createNoActionStepOutput = createNoActionStepOutput;
